import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab9ecf96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "QuotedPriceList" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("签到领苗豆，每日签到可获得5-30苗豆，连续签到可获得更苗豆，苗豆可用于报价，充值，提现等。")
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "userWarpper" }
const _hoisted_5 = { class: "avatar" }
const _hoisted_6 = { class: "user" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "tags" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("城市合伙人")
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "titleWarpper" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("优质采购商")
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "bottomAction" }
const _hoisted_20 = { class: "time" }
const _hoisted_21 = { class: "btn" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("免费报价")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_25 = { class: "telNum" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "notFollow" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "温馨提示", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content1" }, "尊敬的用户，查看信息、免费报价、查看电话等都需要实名认证，请尽快进行身份信息认证！", -1))
const _hoisted_30 = { class: "btn1" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("暂不实名")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("我要实名")
const _hoisted_33 = { class: "notFollow" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "温馨提示", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "尊敬的用户，查看电话需要先对此采购进行报价，尚未报价，请尽快进行报价！", -1))
const _hoisted_36 = { class: "btn" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("暂不报价")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("我要报价")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanNoticeBar = _resolveComponent("VanNoticeBar")!
  const _component_VipTag = _resolveComponent("VipTag")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_RestrictDialog = _resolveComponent("RestrictDialog")!
  const _component_vanButton = _resolveComponent("vanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanSwipe, {
      autoplay: 3000,
      "indicator-color": "white"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (image) => {
          return (_openBlock(), _createBlock(_component_VanSwipeItem, {
            class: "my-swipe",
            key: image
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: image.imageUrl,
                alt: "图片",
                width: "100%",
                height: "100%",
                onClick: ($event: any) => ($setup.junmp(image.linkUrl))
              }, null, 8, ["src", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    ($setup.showCheckIn)
      ? (_openBlock(), _createBlock(_component_VanNoticeBar, {
          key: 0,
          mode: "link",
          color: "#1989fa",
          background: "#ecf9ff",
          "left-icon": "info-o",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:"CheckIn"})))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_VanList, { class: "list" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem",
            key: `item${idx}`,
            onClick: ($event: any) => ($setup.router.push({name:`BuyDetail`,query:{id:item.purchaseId_Str}}))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_VanImage, {
                  src: item.avatars||`https://img.miaodadang.com/avatars/default_head.png?id=1647401090026`,
                  alt: "图片",
                  width: "3rem",
                  height: "3rem",
                  round: ""
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_VipTag, {
                    year: item.year,
                    type: item.year
                  }, null, 8, ["year", "type"]),
                  _withDirectives(_createVNode(_component_VanTag, {
                    size: "small",
                    plain: "",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1536), [
                    [_vShow, item.hasIdCard]
                  ]),
                  _withDirectives(_createVNode(_component_VanTag, {
                    size: "small",
                    plain: "",
                    color: "#6775D2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1536), [
                    [_vShow, item.hasBusinessLicense]
                  ]),
                  _withDirectives(_createVNode(_component_VanTag, {
                    size: "small",
                    plain: "",
                    color: "#F83B2D"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1536), [
                    [_vShow, item.isCityPartner]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.moment(item.createTime).fromNow()), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createVNode(_component_VanTag, { color: "#F83B2D" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, item.isGoodSupplier]
                ])
              ]),
              _createElementVNode("div", {
                class: "similar",
                onClick: _withModifiers(($event: any) => ($setup.router.push({name:"SupplyList",query:{categoryId:item.categoryId,categoryName:item.categoryName}})), ["stop"])
              }, "推荐供应", 8, _hoisted_16)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["area", $setup.classes(idx)]),
              ref_for: true,
              ref: $setup.test
            }, [
              _createTextVNode(_toDisplayString(item.profile), 1),
              _withDirectives(_createElementVNode("span", {
                class: "stow",
                onClick: _withModifiers(($event: any) => ($setup.show(idx)), ["stop"])
              }, "收起", 8, _hoisted_17), [
                [_vShow, !($setup.lineHeightArr[idx]?.showClosing) && $setup.lineHeightArr[idx]?.line >2]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "closing",
                onClick: _withModifiers(($event: any) => ($setup.show(idx)), ["stop"])
              }, "...显示全部", 8, _hoisted_18), [
                [_vShow, $setup.lineHeightArr[idx]?.showClosing]
              ])
            ], 2),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(item.areaName), 1),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_VanButton, {
                  type: "success",
                  onClick: _withModifiers(($event: any) => ($setup.toQuotedPrice(item,item.purchaseId_Str)), ["stop"]),
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_VanButton, {
                  color: "red",
                  onClick: _withModifiers(($event: any) => ($setup.call(item.purchaseId_Str)), ["stop"]),
                  round: "",
                  icon: "phone"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_26)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_RestrictDialog, {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"]),
    _createVNode(_component_VanPopup, {
      show: $setup.isRealName,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.isRealName) = $event)),
      style: {"width":"80vw","border-radius":"4px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.cancelRealName())),
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.gotoRealName())),
              style: {"border":"solid 1px #f00","margin-left":"20px"},
              type: "danger",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      show: $setup.IsBaojia,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (($setup.IsBaojia) = $event)),
      style: {"width":"80vw","border-radius":"4px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.cancelBaoJia())),
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.gotoBaoJia({curlId: _ctx.curlId}))),
              type: "info",
              style: {"border":"solid 1px #ddd","margin-left":"20px"},
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}